var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_129_2844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\xA1\xB5\xE9\x9D\xA2-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M15.7502 25.537C21.3633 24.6926 25.6668 19.8491 25.6668 14.0006C25.6668 7.55733 20.4434 2.33398 14.0002 2.33398C7.55684 2.33398 2.3335 7.55733 2.3335 14.0006C2.3335 19.8491 6.63702 24.6926 12.2502 25.537V17.5006H10.5002C9.53366 17.5006 8.75016 16.7171 8.75016 15.7506C8.75016 14.7842 9.53366 14.0006 10.5002 14.0006H12.2502V11.6673C12.2502 9.41215 14.0783 7.58398 16.3335 7.58398H16.9168C17.8833 7.58398 18.6668 8.36748 18.6668 9.33398C18.6668 10.3005 17.8833 11.084 16.9168 11.084H16.3335C16.0114 11.084 15.7502 11.3452 15.7502 11.6673V14.0006H17.5002C18.4666 14.0006 19.2502 14.7842 19.2502 15.7506C19.2502 16.7171 18.4666 17.5006 17.5002 17.5006H15.7502V25.537Z",
    fill: "#233334"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBlack);
export default __webpack_public_path__ + "static/media/fbBlack.926fda8bd29dd3cc0dfad0c96fdfa400.svg";
export { ForwardRef as ReactComponent };